const initialState = {
    gtmCode: '',
};

function gtmOptions(state = initialState) {
    return state;
}

export default gtmOptions;
